function NavBar() {
  return (
    <nav>
      <div className="nav-logo">
        <span>&lt;/&gt;</span> Ricardo Martins
        <span className="code-dot">.</span>
      </div>
      <ul className="nav-links">
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#technologies">Technologies</a>
        </li>
        <li>
          <a href="#projects">Projects</a>
        </li>
        <li>
          <a href="#experience">Experience</a>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>
      <a className="nav-cta" href="#contact">
        Contact Me
      </a>
    </nav>
  );
}

export default NavBar;
